import React from 'react'
import AliceCarousel from 'react-alice-carousel'
import { IoChevronBackCircleOutline, IoChevronForwardCircleOutline } from 'react-icons/io5'
import OurServicesCard from '../OurServicesCard/OurServicesCard';
import OurServicesCardImg1 from "../../assests/img/our-services-card-img1.jpg"
import OurServicesCardImg2 from "../../assests/img/our-services-card-img2.jpg"
import OurServicesCardImg5 from "../../assests/img/our-services-card-img3.jpg"
import OurServicesCardImg3 from "../../assests/img/our-services-card-img10.png"
import OurServicesCardImg4 from "../../assests/img/child-image.jpg"

const OurAssociation = () => {

    const responsive = {
        0:{items:1},
        400: { items: 1 }, 
        568: { items: 3 },
        1024: { items: 3 },
        1300: { items: 4 },
    };

    const OurServicesData = [
        {
            image: OurServicesCardImg4,
            heading: "CDBS",
            desc: <div>CDBS Scheme by Medicare<br />
                The Child Dental Benefits Schedule is an Australian Government program providing up to $1,095 in benefits over two consecutive calendar years, covering most basic dental services. To be eligible for the CDBS, a child or young person:<br />
                •	must be aged 17 years or under, and<br />
                •	their family must receive Family Tax Benefit Part A or a relevant Australian Government payment
            </div>,
            link: 'https://www.health.nsw.gov.au/oralhealth/Pages/child-dental-benefits-schedule.aspx'
        },
        {
            image: OurServicesCardImg1,
            heading: "Department of Veterans Affairs (DVA) Dental Service Scheme",
            desc: "We are DVA registered services provider, DVA Card holders have access to a range of dental treatments under the DVA program. ",
            link: 'https://www.dva.gov.au/get-support/health-support/health-services/dental-care/dental-services'
        },
        {
            image: OurServicesCardImg2,
            heading: "Area Health Service Vouchers (OHFFSS)",
            desc: <div>NSW Oral Health issues voucher for eligible patients under the Oral Health Fee for Service Scheme (OHFFSS) for treatment from a private dental practitioner for emergency/urgent, general dental care and dentures.
            </div>,
            link: 'https://www.health.nsw.gov.au/oralhealth/Pages/nsw-oral-health-fee-for-service-scheme.aspx#about'
        },
        {
            image: OurServicesCardImg3,
            heading: "Health Fund Cards",
            desc: "We accept all Health Fund cards, having a private health insurance can reduce your dental treatment partially or fully depending on your insurance plan. Our front staff will help you to understand your health fund coverage, treatments covered and billing process.",
        },
        {
            image: OurServicesCardImg5,
            heading: "HICAPPS",
            desc: "Our Practice has HICPAS facility to process all health funds claims, it’s also a fast and easy way to complete invoicing and claiming for select Government Schemes, Private Health Insurers.",
        },
    ]

    return (
        <div className='px-6 sm:px-4 overflow-visible'>
            <div className="flex justify-between items-center my-10">
                <div className="text-[32px] md:text-[56px] font-poppins font-[400]">
                    Payment Options
                </div>
                <div className="underline mb-10 text-[#1A76D1]">
                    View All Associations
                </div>
            </div>
            <div className="bg-transparent my-10">
                <AliceCarousel
                    autoPlayInterval={8000}
                    infinite
                    autoPlayStrategy='default'
                    autoPlay
                    keyboardNavigation
                    items={
                        OurServicesData.map((items) =>
                            
                            <OurServicesCard
                                image={items.image}
                                heading={items.heading}
                                desc={items.desc}
                                link={items.link}
                                isOurAssociation
                            />
                        )}
                    responsive={responsive}
                    renderNextButton={() =>
                        <div className="absolute right-[-2rem] top-1/2 transform -translate-y-1/2">
                            <IoChevronForwardCircleOutline size={28} className='hover:text-[#1A76D1] cursor-pointer' />
                        </div>
                    }
                    renderPrevButton={() =>
                        <div className="absolute left-[-2rem] top-1/2 transform -translate-y-1/2">
                            <IoChevronBackCircleOutline size={28} className='hover:text-[#1A76D1] cursor-pointer' />
                        </div>
                    }
                    disableDotsControls
                />
            </div>
        </div>
    )
}

export default OurAssociation
// import React from 'react'
// import AliceCarousel from 'react-alice-carousel'
// import { IoChevronBackCircleOutline, IoChevronForwardCircleOutline } from 'react-icons/io5'
// import OurServicesCard from '../OurServicesCard/OurServicesCard';
// import OurServicesCardImg1 from "../../assests/img/our-services-card-img1.jpg"
// import OurServicesCardImg2 from "../../assests/img/our-services-card-img2.jpg"
// import OurServicesCardImg5 from "../../assests/img/our-services-card-img3.jpg"
// import OurServicesCardImg3 from "../../assests/img/our-services-card-img10.png"
// import OurServicesCardImg4 from "../../assests/img/child-image.jpg"

// const OurAssociation = () => {

//     const responsive = {
//         0: { items: 1, itemsFit: 'contain' },  // For very small devices
//         568: { items: 2 },  // Changed to 2 for better visibility
//         1024: { items: 3 },
//         1300: { items: 4 },
//     };

//     const OurServicesData = [
//         {
//                         image: OurServicesCardImg4,
//                         heading: "CDBS",
//                         desc: <div>CDBS Scheme by Medicare<br />
//                             The Child Dental Benefits Schedule is an Australian Government program providing up to $1,095 in benefits over two consecutive calendar years, covering most basic dental services. To be eligible for the CDBS, a child or young person:<br />
//                             •	must be aged 17 years or under, and<br />
//                             •	their family must receive Family Tax Benefit Part A or a relevant Australian Government payment
//                         </div>,
//                         link: 'https://www.health.nsw.gov.au/oralhealth/Pages/child-dental-benefits-schedule.aspx'
//                     },
//                     {
//                         image: OurServicesCardImg1,
//                         heading: "Department of Veterans Affairs (DVA) Dental Service Scheme",
//                         desc: "We are DVA registered services provider, DVA Card holders have access to a range of dental treatments under the DVA program. ",
//                         link: 'https://www.dva.gov.au/get-support/health-support/health-services/dental-care/dental-services'
//                     },
//                     {
//                         image: OurServicesCardImg2,
//                         heading: "Area Health Service Vouchers (OHFFSS)",
//                         desc: <div>NSW Oral Health issues voucher for eligible patients under the Oral Health Fee for Service Scheme (OHFFSS) for treatment from a private dental practitioner for emergency/urgent, general dental care and dentures.
//                         </div>,
//                         link: 'https://www.health.nsw.gov.au/oralhealth/Pages/nsw-oral-health-fee-for-service-scheme.aspx#about'
//                     },
//                     {
//                         image: OurServicesCardImg3,
//                         heading: "Health Fund Cards",
//                         desc: "We accept all Health Fund cards, having a private health insurance can reduce your dental treatment partially or fully depending on your insurance plan. Our front staff will help you to understand your health fund coverage, treatments covered and billing process.",
//                     },
//                     {
//                         image: OurServicesCardImg5,
//                         heading: "HICAPPS",
//                         desc: "Our Practice has HICPAS facility to process all health funds claims, it’s also a fast and easy way to complete invoicing and claiming for select Government Schemes, Private Health Insurers.",
//                     },
//     ]

//     return (
//         <div className='px-2 sm:px-4 relative overflow-hidden'>
//             <div className="flex flex-col sm:flex-row justify-between items-center my-6 sm:my-10">
//                 <div className="text-2xl sm:text-[32px] md:text-[56px] font-poppins font-[400] mb-4 sm:mb-0">
//                     Payment Options
//                 </div>
//                 <div className="text-[#1A76D1] underline text-sm sm:text-base">
//                     View All Associations
//                 </div>
//             </div>
//             <div className="bg-transparent relative">
//                 <AliceCarousel
//                     autoPlayInterval={8000}
//                     infinite
//                     autoPlayStrategy='default'
//                     autoPlay
//                     keyboardNavigation
//                     items={
//                         OurServicesData.map((items) =>
//                             <div className="px-2"> {/* Added padding to prevent card cutoff */}
//                                 <OurServicesCard
//                                     image={items.image}
//                                     heading={items.heading}
//                                     desc={items.desc}
//                                     link={items.link}
//                                     isOurAssociation
//                                 />
//                             </div>
//                         )}
//                     responsive={responsive}
//                     renderNextButton={() =>
//                         <div className="absolute right-0 sm:right-[-2rem] top-1/2 transform -translate-y-1/2 z-10">
//                             <IoChevronForwardCircleOutline 
//                                 size={28} 
//                                 className='text-gray-500 hover:text-[#1A76D1] cursor-pointer'
//                             />
//                         </div>
//                     }
//                     renderPrevButton={() =>
//                         <div className="absolute left-0 sm:left-[-2rem] top-1/2 transform -translate-y-1/2 z-10">
//                             <IoChevronBackCircleOutline 
//                                 size={28} 
//                                 className='text-gray-500 hover:text-[#1A76D1] cursor-pointer'
//                             />
//                         </div>
//                     }
//                     disableDotsControls
//                 />
//             </div>
//         </div>
//     )
// }

// export default OurAssociation